<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMinus_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M20.071 12a1 1 0 0 1-1 1H4.929a1 1 0 1 1 0-2H19.07a1 1 0 0 1 1 1"
        clip-rule="evenodd"
    />
</svg>
